import { Table } from '@mantine/core';
import classNames from './Table.module.css';

export default Table.extend({
  defaultProps: {
    striped: 'even',
    verticalSpacing: 'md',
    highlightOnHover: true,
  },
  classNames,
});
